<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">电话订购流程说明</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">电话订购流程说明</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p>
                            <strong><span class="font24">一、夜樱情趣商城官方唯一订购热线：在线客服</span></strong>
                            <!-- <strong><span class="font24">400-660-0606（拨打免费）</span></strong> -->
                        </p>
                        <img src="https://s.cccgx.com/images/20110511/131344c6e51ec403.jpg"><br>
                        <p></p>
                        <br>
                        <br>
                        <!-- <p>
                            <strong><span class="font24">二、电话订购具体流程：</span></strong>
                        </p>
                        <p>
                            <span class="font18">1.拨打400-660-0606；</span>
                        </p>
                        <p>
                            <span class="font18">2.根据语音提示直拨分机或按“0”选择人工服务；</span>
                        </p> -->
                        <p>
                            <span class="font18">2.告知客服人员您所需要的</span>
                            <span style="color: rgb(229, 51, 51); line-height: 2em; font-size: 18px;">商品货号、</span>
                            <span class="font18">收货地址，收货人姓名及手机号码；</span>
                        </p>
                        <p>
                            <span class="font18">3.选择支付方式；</span>
                        </p>
                        <p>
                            <span class="font18">4.订单确认成功等待收货；</span>
                        </p>
                        <span class="font18"><br></span>
                        <p><span class="font18">※温馨提示※<br></span></p>
                        <p>
                            <span class="font18">①如选择在线支付（支付宝/微信），请先将货款支付到客服人员告知的指定账户</span>
                        </p>
                        <p><span class="font18">②收到货物后如有问题，请及时与客服人员联系</span></p>
                        <p><span class="font18">问题没解决？请拨打夜樱情趣商城官热线：联系在线客服</span></p>
                        <br>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/fangshi" style="float:left;">上一篇:订购方式与付款方式</a>
                        <a href="/help/dinggouliucheng" class="pl10" style="float:right">下一篇:夜樱情趣商城订购流程</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.font18{font-size: 18px;}
.font24{font-size:24px;color:#E53333;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;overflow: hidden;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/dianhuadinggou.vue